import { MARITAL_STATUS, OPTION_VALUES, PaymentOptionName } from "@ipru-common/constants/InputValues";
import { LMS_CONSTANTS } from "@ipru-common/constants/SiteConstants";
import { PRODUCT_CODES, PRODUCT_NAMES } from "@ipru-common/constants/products";
import GlobalStore from "@ipru-common/store/GlobalStore";
import { convertToISODate, currencyToWord, readQueryParams } from "../CommonFunctions";
import { getCiTerm } from "../QuoteCommonFunctions";
import _ from "lodash";

const getIPSSuperNetCoreInput = () => {
  const { quoteFormData, calculatorFormData, existingCustomer, currentPageStep, appFormData } =
    GlobalStore.getSnapshot();
  const queryParams = readQueryParams();

  const urlParams = new URLSearchParams(window?.location?.search);
  const params = Object.fromEntries(urlParams?.entries());

  const getCurrentTimeStamp = () => {
    const time = new Date();

    const day = String(time.getDate()).padStart(2, "0");
    const month = String(time.getMonth() + 1).padStart(2, "0");
    const year = time.getFullYear();

    const hours = String(time.getHours()).padStart(2, "0");
    const minutes = String(time.getMinutes()).padStart(2, "0");
    const seconds = String(time.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const getAppFormStep = () => {
    let result = 1;
    if (!appFormData?.appNO) {
      result = 1;
    } else {
      if (appFormData?.stepsCleared?.personalDetails && !appFormData?.stepsCleared?.nomineeDetails) {
        result = 2;
      } else if (appFormData?.stepsCleared?.nomineeDetails && !appFormData?.stepsCleared?.healthDetails) {
        result = 3;
      } else if (appFormData?.stepsCleared?.healthDetails) {
        result = 4;
      }
    }
    return result;
  };

  console.log(quoteFormData, "quoteFormData");

  let ipsUserInputs = {
    productid: PRODUCT_CODES.superIps,
    productname: PRODUCT_NAMES.super,
    timestamp: getCurrentTimeStamp(),
    cover_till_age: quoteFormData?.coverTillAge,
    step: currentPageStep != "appFormScreen" ? "step1" : `step${getAppFormStep()}`,
    accidental_death_benefit: quoteFormData?.ADB_SA || 0,
    accidental_disability_benefit: quoteFormData?.CI_SA || 0,
    adb_cover_gst: quoteFormData?.breakupDetail?.adbPremium,
    adb_cover_without_gst: "",
    adbterm: _.min([quoteFormData?.term, 80 - parseInt(calculatorFormData?.age)]) || 0,
    adjusted_premiun: "",
    age: calculatorFormData?.age,
    annualincome: parseInt(calculatorFormData?.yr_income),
    appno: appFormData?.appNO,
    atpd_cover_gst: quoteFormData?.breakupDetail?.ciPremium,
    atpd_cover_without_gst: "",
    atpdterm:
      getCiTerm(quoteFormData?.paymentOption, calculatorFormData?.age, quoteFormData?.ppt, quoteFormData?.term) || 0,
    channel: quoteFormData?.channel,
    city: calculatorFormData?.city,
    countrycode: calculatorFormData?.country_code,
    countryname: calculatorFormData?.country_of_residence,
    currentpagestep: currentPageStep,
    db_payout_savings_amount: "",
    db_payout_savings_amount_gst: "",
    db_payout_savings_percent: "",
    db_payout_savings_percent_gst: "",
    diabetes: quoteFormData?.isDiabetic === 1 ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    dob: convertToISODate(calculatorFormData?.user_dob),
    dobspouse: "",
    education: calculatorFormData?.calc_education,
    emailid: calculatorFormData?.emailid,
    existing_cust: calculatorFormData?.employeeId || existingCustomer ? "Yes" : "No",
    female_discount_percent: quoteFormData?.breakupDetail?.allDiscounts?.femaleDiscountPercent,
    female_discount_percent_gst: quoteFormData?.breakupDetail?.allDiscounts?.femaleDiscountPercent,
    female_discount_percent_without_gst: "",
    gender: calculatorFormData?.gender,
    isenglish: params?.lan === "hi" ? "FALSE" : "TRUE",
    martialstatus: MARITAL_STATUS[appFormData?.formWizard?.personalDetails?.marital_status] || "",
    mobileno: parseInt(calculatorFormData?.mobileno) || "",
    mrt_sts: MARITAL_STATUS[appFormData?.formWizard?.personalDetails?.marital_status] || "",
    nominee: appFormData?.formWizard?.nomineeDetails?.nominee_first_name || "",
    occupation: calculatorFormData?.calc_occupation,
    online_discount: quoteFormData?.breakupDetail?.allDiscounts?.onlineDiscount,
    online_discount_gst: quoteFormData?.breakupDetail?.allDiscounts?.onlineDiscount,
    online_discount_without_gst: "",
    page_name: LMS_CONSTANTS.IPS_SUPER_PAGE_NAME,
    paymentfrequency: LMS_CONSTANTS[quoteFormData?.tenure],
    payopt: "",
    payterm: "",
    persona: params?.persona || "",
    pincode: parseInt(calculatorFormData?.pincode) || "",
    plan: `${quoteFormData?.planType?.charAt(0).toUpperCase()}${quoteFormData?.planType?.slice(1)}`,
    ppt: quoteFormData?.ppt || 0,
    ppt_savings: "",
    ppt_savings_percent: "",
    ppt_savings_percent_with_gst: "",
    ppt_savings_with_gst: "",
    premium: quoteFormData?.breakupDetail?.total || 0,
    premiumpaymentoption: PaymentOptionName[quoteFormData?.paymentOption],
    premium_3years: "",
    premium_3years_gst: "",
    premium_5years: "",
    premium_5years_gst: "",
    premium_without_gst: "",
    Premium_break: quoteFormData?.premiumBreak,
    qdata: queryParams?.get("qdata") || "",
    salaried_percent: quoteFormData?.breakupDetail?.salariedDiscountAmt,
    salaried_percent_gst: quoteFormData?.breakupDetail?.salariedDiscountPercent,
    salaried_percent_without_gst: "",
    "smart_exit_age 1": "",
    "smart_exit_age 2": "",
    "smart_exit_age 3": "",
    smart_exit_eligible: "",
    spousedetails: "",
    spouseeducation: OPTION_VALUES.EDUCATION.GRADUATE,
    spouseoccupation: OPTION_VALUES.OCCUPATION.HOUSEWIFE,
    spousetobacco: OPTION_VALUES.N_NO,
    staff: calculatorFormData?.staff === OPTION_VALUES.STAFF_N ? OPTION_VALUES.N_NO : OPTION_VALUES.Y_YES,
    sumassured2: currencyToWord(quoteFormData?.SA),
    lifecover: currencyToWord(quoteFormData?.SA),
    term: quoteFormData?.term || 0,
    total_gst: quoteFormData?.breakupDetail?.totalGst,
    trai_flag: calculatorFormData?.trai_flag ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    uid: "",
    usetobacco: calculatorFormData?.tobacco,
    whatsapp_optin: quoteFormData?.wth_option ? "Yes" : "No",
    smart_exit_eligible_age: "",
    smart_exit_entryage:
      quoteFormData?.coverTillAge >= quoteFormData?.entryAge
        ? Math.max(60, calculatorFormData?.age + 26).toString()
        : "",
    smart_exit_upperage:
      quoteFormData?.coverTillAge >= quoteFormData?.entryAge ? (quoteFormData?.coverTillAge - 5).toString() : "",
  };

  return ipsUserInputs;
};

export default getIPSSuperNetCoreInput;
